// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react: true*/
import React, {Fragment, useContext} from 'react';
// @ts-ignore
import {months_long} from '/util/date.js';
import styles from './month_selector.module.less';
import cn from 'classnames';
import {Settings_context} from '../../settings_ctx';
import Icon_chevron_left from '../../img/svg/icon/chevron_left.svg';
import Icon_chevron_right from '../../img/svg/icon/chevron_right.svg';
import Icon_down from '../../img/hola2023/icons/16/chevron_down.svg';
import Icon_left from '../../img/hola2023/icons/16/chevron_left.svg';
import Icon_right from '../../img/hola2023/icons/16/chevron_right.svg';
import {Svg} from '../../ui/svg';

interface i_month_selector_props {
    on_change: (new_month: number, new_year: number)=>void;
    view?: string;
    on_change_view?: (new_view:string)=>void;
    view_month: number;
    view_year: number;
    hide_next?: boolean;
    hide_prev?: boolean;
    dateonly?: boolean;
    mobile?: boolean;
    on_select?: ()=>void;
}

export const Month_selector = ({on_change, view_month, view_year, hide_next,
    hide_prev, dateonly, mobile, on_select}
    :i_month_selector_props)=>{
    const {theme} = useContext(Settings_context);
    const shift_month = diff=>{
        let new_month = view_month + diff;
        let new_year = view_year;
        if (new_month==12)
        {
            new_month = 0;
            new_year++;
        }
        else if (new_month==-1)
        {
            new_month = 11;
            new_year--;
        }
        on_change(new_month, new_year);
    };
    const cls = cn(styles.month_selector, dateonly && styles.dateonly,
        mobile && styles.mobile);
    return <div className={cls} data-elem="month_selector">
      {dateonly && mobile ? <Fragment>
        <div className={styles.arrows}>
          {!hide_prev && <button className={styles.arrow}
            aria-label={'Move to the previous month'}
            onClick={()=>shift_month(-1)}>
            <Svg icon={<Icon_left width={16} height={16}/>}/>
          </button>}
        </div>
        <div className={cn(styles.title, theme.p3, theme.med)}
          data-elem="title">
          <span>{months_long[view_month]} {view_year}</span>
        </div>
        <div className={styles.arrows}>
          {!hide_next && <button className={styles.arrow}
            aria-label={'Move to the next month'}
            onClick={()=>shift_month(1)}>
            <Svg icon={<Icon_right width={16} height={16}/>}/>
          </button>}
        </div>
      </Fragment> : dateonly && !mobile ? <Fragment>
        <div className={cn(styles.title, theme.p3, theme.med)}
          date-elem="title" onClick={on_select}>
          <span>{months_long[view_month]} {view_year}</span>
          <Icon_down width={16} height={16}/>
        </div>
        <div className={styles.arrows}>
          {!hide_prev && <button className={styles.arrow}
            aria-label={'Move to the previous month'}
            onClick={()=>shift_month(-1)}>
            <Svg icon={<Icon_left width={16} height={16}/>}/>
          </button>}
          {!hide_next && <button className={styles.arrow}
            aria-label={'Move to the next month'}
            onClick={()=>shift_month(1)}>
            <Svg icon={<Icon_right width={16} height={16}/>}/>
          </button>}
        </div>
      </Fragment> : <Fragment>
        {!hide_prev && <button className={styles.button_left}
          aria-label={'Move to the previous month'}
          onClick={()=>shift_month(-1)}>
          <Svg icon={<Icon_chevron_left width={4} height={8}/>}/>
        </button>}
        <div className={cn(styles.title, theme.p3, theme.reg)}>
          {months_long[view_month]} {view_year}
        </div>
        {!hide_next && <button className={styles.button_right}
          aria-label={'Move to the next month'}
          onClick={()=>shift_month(1)}>
          <Svg icon={<Icon_chevron_right width={4} height={8}/>}/>
        </button>}
      </Fragment>}
    </div>;
};
